import React from "react";
import PowerIcon from "@material-ui/icons/PowerSettingsNew";
import Tooltip from "@material-ui/core/Tooltip/index";

export default function PowerButton({ id, isActive, onUpdateUserStatus }) {
  return (
    <Tooltip title={isActive ? "Active" : "Deactive"} placement="top">
      <button
        aria-label={isActive ? "Active" : "Deactive"}
        className={`btn mr-2 btn-sm btn-icon btn-bg-light ${
          isActive ? "btn-text-success" : "btn-text-danger"
        }`}
        onClick={() => onUpdateUserStatus(id, isActive)}
      >
        <PowerIcon />
      </button>
    </Tooltip>
  );
}
